import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import AnalistaDashboard from "../pages/Analista/Dashboard";
import AnalistaConsulta from "../pages/Analista/Consulta";
import AnalistaGerenciamentoPro from "../pages/Analista/GerenciamentoDeProcessos";
import AnalistaStepTwo from "../pages/Analista/StepTwo";
import AnalistaStepThree from "../pages/Analista/StepThree";
import AnalistaStepFive from "../pages/Analista/StepFour";
import AnalistaProcessError from "../pages/Analista/ProcessError";

import { DataProvider } from "../contexts/QuestionContext";

import Sidebar from "../components/Sidebar";

function AnalistRoutes() {
	return (
		<>
			<Switch>
				<DataProvider>
					<Route path='/dashboard'>
						<Sidebar />
						<AnalistaDashboard />
					</Route>
					<Route path='/gerenciamento-de-processos'>
						<Sidebar />
						<AnalistaGerenciamentoPro />
					</Route>
					<Route path='/consulta'>
						<Sidebar />
						<AnalistaConsulta />
					</Route>
					<Route path='/step-two'>
						<Sidebar />
						<AnalistaStepTwo />
					</Route>
					<Route path='/step-three'>
						<Sidebar />
						<AnalistaStepThree />
					</Route>
					<Route path='/step-four'>
						<Sidebar />
						<AnalistaStepFive />
					</Route>
					<Route path='/processo-com-erro&id=:id'>
						<Sidebar />
						<AnalistaProcessError />
					</Route>
				</DataProvider>
			</Switch>

			<Redirect to='/dashboard' />
		</>
	);
}

export default AnalistRoutes;
